<template>
	<div class="page-container">
		<div class="content" style="width: 100%; height: 100%">
			<!-- 		<div class="top-content">
				<div class="searchbox mr-10">
					<input type="text" v-model="searchWord" placeholder="搜索关键词" />
				</div>
				<span class="btn bg-default mr-10" v-on:click="searchClick()">查询</span>
			</div> -->
			<div id="map-container">
				<!-- <div class="order-container" v-if="isShow"> -->
				<!-- <div class="order-container">
					<div class="order-tit">订单数据(订单量:{{ orderList.length }})</div>
					<div class="order-list">
						<div class="order-item" v-for="(item, index) in orderList" :key="index">
							<img src="@/assets/images/order-map.png" alt="" />
							<div class="order">
								<div>订单号:{{ item.odrId }}</div>
								<div>技师:{{ item.odrRptName }}</div>
								<div>时间:{{ item.odrEndTime }}</div>
							</div>
						</div>
					</div>
				</div> -->
				<!--  <div class="order-container" v-if="isShowArea"> -->

				<div id="container" :style="{ height: mapHeight + 'px' }"></div>
			</div>
			<span id="countdown"
				:style="{left: (hiddenFlag === false ? '0% !important' : (screenWidth < 1500 ? (screenWidth <= 1024 ? '12.5% !important' : '6.5% !important') : '1.5% !important'))}">
				<strong id="countDownTime" v-cloak="">{{countdownSeconds}}</strong> 秒后刷新数据</span>

			<div class="order-container">
				<div class="order-tit">
					<span @click="changeTit(0)" :class="index == 0 ? 'active' : ''">车辆列表</span>
					<!-- <span @click="changeTit(1)" :class="index == 1 ? 'active' : ''">订单轨迹
					</span> -->
				</div>
				<div class="flex flex-y-center" style="margin-top: 10px;margin-left: 10px;">
					<div class="maptop_input">
						<el-input placeholder="请输入车牌号" v-model="searchWord"></el-input>
					</div>
					<div class="mapsearch_btn" @click="getData">查询</div>
				</div>
				<div class="order-list" v-if="index == 0">
					<div class="bottom_content">
						<div class="table_container" v-bind:id="tableId">
							<el-table v-bind:data="tableData" row-key="id" @selection-change="handleSelectionChange"
								@row-click="handleRowClick" style="width: 100%;font-size: 12px;"
								v-bind:header-cell-style="{color: '#333333',background: '#F5F5F5',}"
								v-bind:max-height="tableHeight" empty-text="暂无数据">
								<el-table-column type="selection"> </el-table-column>
								<el-table-column prop="vehNo" label="车牌号"></el-table-column>
								<el-table-column label="行驶状态">
									<template #default="scope">
										<span v-if="scope.row.location == null" style="color: #999999;">离线</span>
										<span v-else-if="scope.row.runStatue == 1" style="color: #0000ff;">行驶</span>
										<span v-else style="color: #E36A19;">停车</span>
									</template>
								</el-table-column>
								<el-table-column prop="curOdrStatus" label="运单任务">
									<template #default="scope">
										<span v-if="scope.row.curOdrStatus == null" style="color: #0000ff;">空闲</span>
										<span v-else-if="scope.row.curOdrStatus == '0001'" style="color: #E36A19;">待接单</span>
										<span v-else-if="scope.row.curOdrStatus == '0003'" style="color: #E36A19;">待开始</span>
										<span v-else-if="scope.row.curOdrStatus == '0010'" style="color: #E36A19;">待装货</span>
										<span v-else-if="scope.row.curOdrStatus == '0011'" style="color: #E36A19;">待分装</span>
										<span v-else-if="scope.row.curOdrStatus == '0020'" style="color: #E36A19;">待卸货</span>
										<span v-else-if="scope.row.curOdrStatus == '0021'" style="color: #E36A19;">待分卸</span>
										<span v-else-if="scope.row.curOdrStatus == '0030'" style="color: #E36A19;">回程中</span>
									</template>
								</el-table-column>

							</el-table>
						</div>
						<!-- <div class="flex flex-y-center flex-x-center">
							<el-config-provider :locale="locale">
								<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
									:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
									:total="totalCount" @size-change="getData" @current-change="getData" />
							</el-config-provider>
						</div> -->
					</div>
					<!-- <div class="order-item" v-for="(item, index) in areaList" :key="index" @click="areaClick(item)">
						<img src="@/assets/images/order-map.png" alt="" />
						<div class="order">
							<div>区域{{ item.centerName }}</div>
							<div>订单量:{{ item.odrCount }}</div>
							<div class="address" :title="item.address">
								地址:{{ item.address }}
							</div>
						</div>
					</div> -->
				</div>
				<div class="order-list" v-if="index == 1">
					<div
						style="display: flex;flex-direction: column;padding: 5 5px;align-items: center;justify-content: flex-start;">
						时间：
						<el-date-picker style="width: 250px; height: 35px" v-model="pLoaddayArr" type="datetimerange"
							range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
							format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
						</el-date-picker>
					</div>
					<!-- <div class="order-item" v-for="(item, index) in areaOrderList" :key="index">
						<img src="@/assets/images/order-map.png" alt="" />
						<div class="order">
							<div>订单号:{{ item.odrId }}</div>
							<div>技师:{{ item.odrRptName }}</div>
							<div>时间:{{ item.odrEndTime }}</div>
						</div>
					</div> -->
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		onUnmounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import {
		parseTime,
		formatDateString,
	} from "@/libs/tools";
	import {
		getShowIcon,
		getACCStatus,
		getCarStatus,
	} from "@/libs/mapUtils";
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		throwStatement
	} from "@babel/types";
	import {
		dataTool
	} from "echarts";

	export default defineComponent({
		components: {},
		name: "vehicleMap",

		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				screenWidth: document.documentElement.clientWidth,
				screenHeight: document.documentElement.clientHeight,
				tableId: "roleManagementTable",
				dayType: "n",
				mapHeight: 400,
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				orgId: "",
				orgList: [],
				maplist: [],
				map: null,
				cluster: null,
				startTime: "",
				endTime: "",
				value1: [],
				markers: [],
				isShow: true,
				newArr: [],
				orderList: [],
				radius: null,
				odrGatherCount: "",
				mapItemList: [],
				positionData: null,

				circlesList: [], //圆形数组
				areaList: [], //区域数组
				areaOrderList: [],
				isShowArea: true,
				index: 0,
				minPoints: null,
				areaAllOrder: [],
				odrCount: 0,
				selectedRows: [], // 用于存储选中的行数据数组。
				canSendInstruction: false,
				canUpdateVehicle: false,
				tabType: 'all',
				infoWindow: null,
				timer: '',
				countdownSeconds: 60,
				countdownLimitSeconds: 60,
				hiddenFlag: true,
			});


			onMounted(() => {
				nextTick(() => {
					var offsetHeight = document.querySelector("#map-container").offsetHeight;
					if (offsetHeight <= 0) {
						return false;
					}
					data.mapHeight = document.querySelector(" #map-container").offsetHeight;

					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;

					initDOMAndEvents();
					initMap();

					clearInterval(data.timer);
					data.timer = setInterval(function() {
						data.countdownSeconds--;
						if (data.countdownSeconds === -1) {
							data.countdownSeconds = data.countdownLimitSeconds;
							getData();
						}
					}, 1 * 1000);

				});


				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;

						// 监听浏览器大小发生改变
						data.screenWidth = document.documentElement.clientWidth;
						data.screenHeight = document.documentElement.clientHeight;
					});
				};

			});

			onUnmounted(() => {
				clearInterval(data.timer);

				if (data.cluster !== null && data.cluster !== undefined) {
					data.cluster.clearMarkers();
					data.cluster.setMap(null);

					data.cluster = null;
				}

				if (data.map !== null && data.map !== undefined) {
					data.map.destroy();
					data.map = null;
				}
			});

			const initDOMAndEvents = () => {
				//初始化窗口点击事件
				window.naviTrackPlayback = (event) => {
					const e=event.currentTarget
					const vehicleNo=e.getAttribute('data-plateNo')
					const vehicleID=e.getAttribute('data-vehicleID')
					console.log(vehicleNo);
					naviTrackPlayback(vehicleNo,vehicleID);
				}
				
				window.naviRoadPlayback = (event) => {
					const e=event.currentTarget
					const vehicleNo=e.getAttribute('data-plateNo')
					const vehicleID=e.getAttribute('data-vehicleID')
					console.log(vehicleNo);
					naviRoadPlayback(vehicleNo,vehicleID);
				}
				// var contentDiv = document.querySelector("template");
				// if (contentDiv) {
				// 	contentDiv.addEventListener('click', function() {
				// 		naviTrackPlayback();
				// 		console.log('跳转到轨迹回放页面');
				// 	});
				// }

				//跳转实时追踪
				// body.on('click', '#track', function () {
				//     that.naviRealTimeTracks($(this).attr('data-plateNo'), $(this).attr('data-vehicleNo'), $(this).attr('data-onlineStatus'), $(this).attr('data-icon-type'))
				// });

				//跳转轨迹回放
				// body.on('click', '#history', function() {
				// 	naviTrackPlayback();
				// });

				// // 关注
				// body.on('click', '#addFocus, #cancelFocus', function() {
				// 	naviTrackPlayback();
				// })

			};

			//初始化地图
			const initMap = () => {
				AMapLoader.load({
						key: "e43a295f15ed06c429ff79a20f5331f0",
						version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
						plugins: [
							"AMap.Geolocation",
							"AMap.AutoComplete",
							"AMap.PlaceSearch",
							"AMap.Geocoder",
							"AMap.IndexCluster",
							"AMap.MarkerClusterer",
						], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
						AMapUI: {
							// 是否加载 AMapUI，缺省不加载
							version: "1.1", // AMapUI 版本
							plugins: ["overlay/SimpleMarker"], // 需要加载的 AMapUI ui插件
						},
						Loca: {
							// 是否加载 Loca， 缺省不加载
							version: "2.0", // Loca 版本
						},
					})
					.then((AMap) => {
						// console.log(AMap)
						data.map = new AMap.Map("container", {
							//设置地图容器id
							viewMode: "3D", //是否为3D地图模式
							zoom: 5, //初始化地图级别
							center: [107.140000, 29.024000], //初始化地图中心点位置
							animateEnable: false,
						});


						data.infoWindow = new AMap.InfoWindow({
							offset: new AMap.Pixel(10, -25)
						});



						data.map.plugin(["AMap.MarkerClusterer", "AMap.MouseTool"], function() {
							// 初始化点聚合、鼠标工具
							data.cluster = new AMap.MarkerClusterer(data.map, [], {
								minClusterSize: 100
							});

							//     mouseTool = new AMap.MouseTool(amapMap);

							//     //添加事件
							//     AMap.event.addListener(mouseTool, 'draw', function (e) {
							//         // if (that.$refs.mapTools.getRuleDistance == true) {
							//         //     that.$refs.mapTools.getRuleDistance = false;
							//         // } else if (that.$refs.mapTools.getMeasureArea == true) {
							//         //     that.$refs.mapTools.getMeasureArea = false;
							//         // }
							//         // mouseTool.close(false);
							//     })
						});
						//this.getNowDay();
						getData();
					})
					.catch((e) => {});
			};

			//获取列表数据
			const getData = async () => {

				data.maplist = [];
				if (data.cluster) {
					//清除 聚合点
					data.cluster.setMap(null);
				}

				let params = {};
				const r = await proxy.$http.postFormData(apiObj.getAllVehLocathion, params, {
					showLoading: false
				});
				console.log(r);
				if (r.respCode == "0000") {
					data.tableData = r.data;

					r.data.forEach((el) => {
						if (el.location !== null && el.location !== undefined && el.location !=
							"") {
							data.positionData = el.location;
							showInformation('在线', el.vehId, el.vehNo, 1, '1', false);

						}
					});
				}
			};

			//点击列表车辆
			const clickAllVehicleRow = async (vehId, vehNo, terImei) => {

				let params = {
					vehId: vehId,
				};
				const r = await proxy.$http.postFormData(apiObj.getVehLocathion, params);
				console.log(r);
				if (r.respCode == "0000") {
					let currindex = data.tableData.findIndex(item => item.vehId === vehId);
					data.tableData[currindex].location = r.data.location;
					data.positionData = r.data.location;
					showInformation('在线', vehId, vehNo, 1, '1', true);

					data.map.setCenter([r.data.location.longitude, r.data.location.latitude]);
					// data.tableData = r.data;
					// data.positionData = r.data;

					// r.data.forEach((el) => {
					// 	if (el.location !== null && el.location !== undefined && el.location !=
					// 		"") {
					// 		data.positionData = el.location;
					// 		showInformation('在线', el.terImei, el.vehNo, 1, '1');

					// 	}
					// });
				}
			};

			const showInformation = (onlineStatus, vehicleID, plateNo, iconType, concern, isCenter) => {
				var marker = null;
				var markerImage = '',
					markerUrl = '',
					alarmContent = '';
				var isMatch = false,
					circle = null,
					listIndex = -1,
					direction = 0,
					mapItem = null;
				let longitude = '',
					latitude = '',
					gsmSignal = '',
					gpsSignal = '';
				let satelliteDate = '',
					deviceId = '',
					switchStatus = '',
					mileage = '',
					speed = '',
					terminalTypeName = '',
					mcc = '',
					mnc = '',
					lac = '',
					cell = '',
					simno = '',
					warnName = '',
					status = '',
					statusName = '',
					drive = '';
				let address = '',
					newAddress = '-',
					vehicleCode = '',
					imgUrl = '';


				if (data.positionData !== null && data.positionData !== undefined && data.positionData !=
					"") {
					longitude = data.positionData.longitude || '';
					latitude = data.positionData.latitude || ''; //longitude: ""
					gsmSignal = data.positionData.gsmSignal;
					gpsSignal = data.positionData.gpsSignal;
					satelliteDate = data.positionData.satelliteDate;
					deviceId = data.positionData.deviceid;
					switchStatus = data.positionData.onlineStatus;
					mileage = data.positionData.mileage;
					speed = data.positionData.speed;
					// terminalTypeName = positionData[0].typeName;
					address = data.positionData.address;
					status = data.positionData.status;
					warnName = data.positionData.warnName;
					statusName = data.positionData.statusName;
					drive = data.positionData.drive;

					mcc = data.positionData.mcc;
					mnc = data.positionData.mnc;
					lac = data.positionData.lac;
					cell = data.positionData.cell;

					// 获取设备报警信息
					if (warnName && statusName) {
						if (warnName !== '[]' && statusName !== '[]') {
							alarmContent = warnName.substr(1, warnName.length - 1) + ',' +
								statusName.substr(1, statusName.length - 1) + ',';
						} else if (warnName === '[]' && statusName !== '[]') {
							alarmContent = statusName.substr(1, statusName.length - 1) +
								',';
						} else if (warnName !== '[]' && statusName === '[]') {
							alarmContent = warnName.substr(1, warnName.length - 1) + ',';
						}
					}

					data.mapItemList.forEach(function(item, index) {
						if (item.vehicleID == vehicleID || item.plateNo ==
							plateNo) {
							// 由于marker在地图上累加显示，先要找到对应设备的marker
							isMatch = true;
							listIndex = index;
						}
					});

					if ((longitude !== '' && latitude !== '') && (longitude !== '∞' &&
							latitude !== '∞') && (longitude != null && latitude != null) &&
						(longitude != 'Infinity' && latitude != 'Infinity') && (
							longitude != '-Infinity' && latitude != '-Infinity')) {

						markerImage = getShowIcon(iconType, 'markerIcon',
							onlineStatus, alarmContent, speed || 0);

						//markerUrl=require(markerImage);
						// imgUrl = require(`@/assets/${markerImage}`);
						imgUrl = require("@/assets/" + markerImage);


						if (iconType <= 2) {
							direction = parseInt(data.positionData.direction);
						}


						if (listIndex != -1) {
							// marker已创建，更新经纬度及角度
							mapItem = data.mapItemList[listIndex];

							mapItem.marker.setPosition([longitude, latitude]);
							mapItem.marker.setContent('<img src="' + imgUrl +
								'" style="width: 40px;height: 40px;transform: rotate(' +
								direction + 'deg)"/>');

							if (mcc || mnc || lac || cell) {
								if (mapItem.circle == null) {
									mapItem.circle = new AMap.Circle({
										center: [longitude, latitude],
										radius: 200,
										map: data.map,
										fillColor: '#f3f2a2',
										strokeColor: '#243290',
										strokeWeight: 1,
										zIndex: 1,
									})
								} else {
									mapItem.circle.show();
									mapItem.circle.setCenter([longitude, latitude]);
								}
							} else if (mapItem.circle !== null) {
								mapItem.circle.hide();
								mapItem.circle.setCenter([longitude, latitude]);
							}
						}

						if (isMatch === false) {
							// marker未创建，创建

							marker = new AMap.Marker({
								map: data.map,
								position: [longitude, latitude],
								content: '<img src="' + imgUrl +
									'" style="width: 40px;height: 40px;transform: rotate(' +
									direction + 'deg)"/>',
								label: {
									content: plateNo, //设置文本标注内容
									direction: 'bottom' //设置文本标注方位
								},
							});

							if (mcc || mnc || lac || cell) {
								circle = new AMap.Circle({
									center: [longitude, latitude],
									radius: 200,
									map: data.map,
									fillColor: '#f3f2a2',
									strokeColor: '#243290',
									strokeWeight: 1,
									zIndex: 1,
								})
							}

							data.mapItemList.push({
								plateNo: plateNo,
								vehicleID: vehicleID,
								marker: marker,
								circle: circle
							})
							// data.cluster.addMarker(marker);
							listIndex = data.mapItemList.length - 1;
						} else {

						}

					} else {
						console.log('暂无定位信息！');
					}

					if (listIndex != -1) {
						marker = data.mapItemList[listIndex].marker;
						marker.content =
							"<div id='markerContent' style='width: 600px; border-radius: 10px; padding: 10px 0; background: rgba(0, 0, 0, 0)'>" +
							"   <div style='text-align:right;padding-right:20px'>" +
							"       <img src='" + require('@/assets/images/small1.png') +
							"' style='vertical-align: middle;margin-right: 5px' alt=''/>" +
							(gsmSignal === null || gsmSignal === undefined || gsmSignal === '' ? '-' :
								gsmSignal) +
							"       <img src='" + require('@/assets/images/small3.png') +
							"' style='margin-left:7px;vertical-align: middle;margin-right: 5px'  alt=''/>" +
							(gpsSignal === null || gpsSignal === undefined || gpsSignal === '' ? '-' :
								gpsSignal) +
							"       <img src='" + require('@/assets/images/small2.png') +
							"' style='margin-left:7px;vertical-align: middle;' alt=''/>" +
							"       <img style='margin-left:7px;vertical-align: middle;' src='" + require(
								'@/assets/images/small4.png') +
							"' style='vertical-align: middle;' alt=''/>" +
							"       <img style='vertical-align: middle;margin-left:7px;' src='" + require(
								'@/assets/images/small5.png') + "'  alt=''/>" +
							"   </div>" +
							"   <div style='padding-left:15px;color: #666;font-size: 12px;padding-top: 8px;'>" +
							"       <span id='plateNo' style='display: inline-block;width: 49%;'>名称：<b>" +
							(plateNo === null || plateNo === '' ? '-' : plateNo) + "</b></span>  " +
							"       <span style='display: inline-block;width: 49%;' >当日里程：<b id='i2'>" +
							parseInt(mileage / 1000) + " km</b></span>" +
							"   </div>" +
							"   <div style='padding-left:15px;color: #666;font-size: 12px;padding-top: 8px;'>" +
							"       <span style='display: inline-block;width: 49%;'>设备号：<b>" + (
								deviceId === null || deviceId === '' ? '-' : deviceId) + "</b></span>  " +
							"       <span style='display: inline-block;width: 49%;' >速度：<b id='i3'>" + (
								speed === null || speed === undefined || speed === '' ? '0' : speed) +
							" km/h</b></span> " +
							"   </div>" +
							"   <div style='padding-left:15px;color: #666;font-size: 12px;padding-top: 8px;'>" +
							"       <span style='display: inline-block;width: 49%;' >设备状态：<b id='i1'>" + (
								onlineStatus === null || onlineStatus === '' ? '-' : onlineStatus) +
							"</b></span>  " +
							"       <span style='display: inline-block;width: 49%;'>定位时间：<b>" + (
								satelliteDate === null || satelliteDate === undefined || satelliteDate ===
								'' ? '-' : formatDateString(satelliteDate)) + "</b></span>" +
							"   </div>" +
							"   <div style='padding-left:15px;color: #666;font-size: 12px;padding-top: 8px;'>" +
							"       <span style='display: inline-block;width: 49%;'>运动状态：<b>" + (status ===
								null || status === undefined || status === '' ? '-' : getACCStatus(
									status)) + "</b></span>" +
							"       <span style='display: inline-block;width: 49%;'>状态：<b>" + (
								getCarStatus(warnName, statusName, drive, iconType)) + "</b></span>" +
							"   </div>" +
							"   <div class='footer' style='height: 20px;padding-top:10px;font-size:13px;color:#5F89FB;line-height: 20px;background: #fff;margin-top: 5px;text-align: center;'>" +
							"       <span id='track' data-plateNo='" + plateNo + "' data-vehicleNo='" +
							deviceId + "' data-onlineStatus='" + (onlineStatus === null || onlineStatus ===
								'' ? 'offline' : (onlineStatus === '在线' ? 'online' : 'offline')) +
							"' data-icon-type='" + iconType +
							"' style='display:inline-block;width:88px;text-align:center;cursor:pointer;'>" +
							"       <img src='" + require('@/assets/images/icon-track.png') +
							"' style='width: 16px;height: 16px;margin-right: 5px;vertical-align: middle'>追踪</span>" +

							"       <span id='history' onclick='naviTrackPlayback(event)' data-plateNo='" +
							plateNo + "' data-vehicleNo='" +
							deviceId + "' data-vehicleID='" + vehicleID + "' data-icon-type='" + iconType +
							"' style='display:inline-block;width:88px;text-align:center;cursor:pointer;'>" +
							"       <img src='" + require('@/assets/images/icon3.png') +
							"' style='width: 13px;height: 13px;margin-right: 5px;vertical-align: middle;' alt=''/>轨迹</span>" +

							(concern !== '1' ? "<span id='addFocus' data-vehicleIMEI='" + deviceId +
								"' data-concern='2' style='display:inline-block;width:100px;text-align:center;cursor:pointer;'>" +
								"<img src='" + require('@/assets/images/icon-hollow.png') +
								"' style='width: 13px;height: 13px;margin-right: 5px;vertical-align: middle;' alt=''/>添加关注</span>" :
								"<span id='cancelFocus' data-vehicleIMEI='" + deviceId +
								"' data-concern='1' style='display:inline-block;width:100px;text-align:center;cursor:pointer;'>" +
								"<img src='" + require('@/assets/images/icon-solid.png') +
								"' style='width: 13px;height: 13px;margin-right: 5px;vertical-align: middle;' alt=''/>取消关注</span>"
							) +

							(data.canSendInstruction ? "       <span id='direction' data-plateNo='" +
								plateNo + "' data-vehicleNo='" + deviceId +
								"' style='display:inline-block;width:88px;text-align:center;cursor:pointer;'>" +
								"       <img src='../images/icon-send-direction.png' style='width: 16px;height: 16px;margin-right: 5px;vertical-align: middle'>指令</span>" :
								"") +

							(data.canUpdateVehicle ? "       <span id='modify' data-tabType='" + data
								.tabType + "' data-index1='" + index1 + "' data-index2='" + index2 +
								"' data-plateNo='" + plateNo + "' data-vehicleNo='" + deviceId +
								"' data-vehicleID='" + vehicleID + "' data-icon-type='" + iconType +
								"' style='display:inline-block;width:88px;text-align:center;cursor:pointer;'>" +
								"       <img src='../images/icon-edit.png' style='width: 13px;height: 13px;margin-right: 5px;vertical-align: middle;' alt=''/>资料</span>" :
								"") +
							"   </div>" +
							"</div>";

						if (isMatch === false) {
							// marker的点击事件未初始化
							marker.on('click', markerClick);
							// marker.emit('click', {
							// 	target: marker
							// });
						}

						if (isCenter) {
							data.infoWindow.setContent(marker.content);
							data.infoWindow.open(data.map, marker.getPosition());

							data.map.setCenter([longitude, latitude]);
						}

						function markerClick(e) {
							// AMap.plugin('AMap.Geocoder', function() {
							// 	var geocoder = new AMap.Geocoder();
							// 	geocoder.getAddress(e.target.getPosition(), function(status,
							// 		result) {
							// 		if (status === 'complete' && result.info === 'OK') {
							// 			address = result.regeocode.formattedAddress;
							// 		}
							// 	})
							// });

							data.infoWindow.setContent(e.target.content);
							data.infoWindow.open(data.map, e.target.getPosition());

						}
					}
				} else {
					console.log('暂无定位信息！');
				}
			};

			// 轨迹跳转
			const naviTrackPlayback = (vehicleNo,vehicleID) => {
				window.open('vehicleMapTrack?plateNo='+ vehicleNo+'&vehicleID='+vehicleID, '_blank');
			};
			
			// 路线跳转
			const naviRoadPlayback = (vehicleNo,vehicleID) => {
				window.open('orderTrack?plateNo='+ vehicleNo+'&vehicleID='+vehicleID, '_blank');
				// window.open("newLinePlay.html?page=latestLocation&plateNo=" + plateNo + "&vehicleNo=" +
				// 	vehicleNo + '&vehicleID=' + vehicleID + '&iconType=' + iconType);
			};

			// 切换
			const changeTit = (index) => {
				data.index = index;
			};

			const handleSelectionChange = (selection) => {
				data.selectedRows = selection; // 更新选中的行数据数组。
				console.log(data.selectedRows); // 打印选中的行数据。
			};

			const handleRowClick = (row, column, event) => {
				console.log('行点击事件触发了');
				console.log('点击的行数据：', row); // row 是被点击的行数据对象
				console.log('点击的行数据：', row.vehNo); // row 是被点击的行数据对象
				console.log('点击的列数据：', column); // column 是被点击的列数据对象
				console.log('原生事件对象：', event); // event 是原生 DOM 事件对象

				clickAllVehicleRow(row.vehId, row.vehNo, row.terImei);
			};


			return {
				...toRefs(data),
				getData,
				changeTit,
				handleRowClick,
				handleSelectionChange,
				naviTrackPlayback,
				naviRoadPlayback,
			};
		},
	});


	// // 时间类型
	// getDayType(dayType) {
	// 	this.dayType = dayType;
	// 	if (dayType == "q") {
	// 		this.getSubDay(this.startTime, this.endTime);
	// 	}
	// 	if (dayType === "n") {
	// 		this.getNowDay();
	// 	}
	// 	if (dayType === "h") {
	// 		this.getAddDay(this.startTime, this.endTime);
	// 	}
	// },
	// // 前一天
	// getSubDay(startTime, endTime) {
	// 	this.startTime = this.formattedTime(startTime, "sub");
	// 	this.endTime = this.formattedTime(endTime, "sub");
	// 	this.value1 = [];
	// 	this.value1.push(new Date(this.startTime), new Date(this.endTime));
	// 	this.getMapList();
	// },
	// // 今天
	// getNowDay() {
	// 	var date = new Date();
	// 	var year = date.getFullYear();
	// 	var month = date.getMonth() + 1;
	// 	var day = date.getDate();
	// 	month = month > 9 ? month : "0" + month;
	// 	day = day < 10 ? "0" + day : day;
	// 	this.startTime = year + "-" + month + "-" + day;
	// 	this.endTime = year + "-" + month + "-" + day;
	// 	this.value1 = [];
	// 	this.value1.push(new Date(this.startTime), new Date(this.endTime));
	// 	this.getMapList();
	// },
	// // 后一天
	// getAddDay(startTime, endTime) {
	// 	this.startTime = this.formattedTime(startTime, "add");
	// 	this.endTime = this.formattedTime(endTime, "add");
	// 	this.value1 = [];
	// 	this.value1.push(new Date(this.startTime), new Date(this.endTime));
	// 	this.getMapList();
	// },
	// formattedTime(time, type) {
	// 	var curDate = new Date(time);
	// 	if (type === "add") {
	// 		var preDate = new Date(curDate.getTime() + 24 * 60 * 60 * 1000); //前一天
	// 	}
	// 	if (type === "sub") {
	// 		var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
	// 	}

	// 	var year = preDate.getFullYear();
	// 	var month = preDate.getMonth() + 1;
	// 	var day = preDate.getDate();
	// 	month = month > 9 ? month : "0" + month;
	// 	day = day < 10 ? "0" + day : day;
	// 	let date = year + "-" + month + "-" + day;
	// 	return date;
	// },
	// // 获取时间
	// getTime() {
	// 	this.dayType = "";
	// 	if (this.value1) {
	// 		this.startTime = parseTime(this.value1[0], "{y}-{m}-{d}");
	// 		this.endTime = parseTime(this.value1[1], "{y}-{m}-{d}");
	// 	}
	// 	if (!this.value1) {
	// 		this.startTime = "";
	// 		this.endTime = "";
	// 	}
	// 	this.maplist = [];
	// 	if (this.cluster) {
	// 		//清除 聚合点
	// 		this.cluster.setMap(null);
	// 	}
	// 	this.isShow = false;
	// 	this.radius = null;
	// 	this.minPoints = null;
	// 	this.odrGatherCount = "";
	// 	this.isShowArea = false;
	// 	this.index = 0;
	// 	this.getMapList();
	// },
	// const searchClick = () => {
	// 	data.maplist = [];
	// 	if (data.cluster) {
	// 		//清除 聚合点
	// 		data.cluster.setMap(null);
	// 	}
	// 	if (data.circlesList.length > 0) {
	// 		data.circlesList.forEach((circle) => {
	// 			data.map.remove(circle);
	// 		});
	// 	}
	// 	data.isShow = false;
	// 	data.radius = null;
	// 	data.minPoints = null;
	// 	data.odrGatherCount = "";
	// 	data.isShowArea = false;
	// 	data.index = 0;
	// 	this.getMapList();
	// };
	// 获取list
	// const getMapList = async () => {
	// 	if (data.cluster) {
	// 		//清除 聚合点
	// 		data.cluster.setMap(null);
	// 	}
	// 	if (data.circlesList.length > 0) {
	// 		data.circlesList.forEach((circle) => {
	// 			data.map.remove(circle);
	// 		});
	// 	}
	// 	data.isShow = false;
	// 	data.radius = null;
	// 	data.minPoints = null;
	// 	data.odrGatherCount = "";
	// 	data.isShowArea = false;
	// 	data.index = 0;
	// 	let params = {
	// 		startTime: data.startTime,
	// 		endTime: data.endTime,
	// 		orgId: data.orgId,
	// 		searchWord: data.searchWord,
	// 	};
	// 	const r = await proxy.$http.postFormData(
	// 		"/biz/bdzl/advertising/odrDistribution",
	// 		params
	// 	);
	// 	console.log(r);
	// 	if (r.respCode === "0000") {
	// 		getTwodimensionalArray(
	// 			JSON.parse(JSON.stringify(r.odrLocation)),
	// 			r.odrLocation
	// 		);
	// 		if (data.orgId && r.odrLocation && r.odrLocation.length > 0) {
	// 			data.map.setZoomAndCenter(
	// 				10,
	// 				r.odrLocation[0].odrCustLnglat.split(",")
	// 			);
	// 		}
	// 		data.maplist = [];
	// 		r.odrLocation.forEach((item, index) => {
	// 			let obj = {
	// 				lnglat: item.odrCustLnglat.split(","),
	// 				text: item.odrId,
	// 				odrCustLnglat: item.odrCustLnglat,
	// 			};

	// 			data.maplist.push(obj);
	// 		});
	// 		data.odrCount = r.odrCount;
	// 		setTimeout(() => {
	// 			if (r.odrLocation.length > 0) {
	// 				initPoints();
	// 			}
	// 		}, 500);
	// 	}
	// };
	// 数组
	// const getTwodimensionalArray = (arr, oldArr) => {
	// 	for (var i = 0; i < arr.length - 1; i++) {
	// 		for (var j = i + 1; j < arr.length; j++) {
	// 			if (arr[i].odrCustLnglat == arr[j].odrCustLnglat) {
	// 				arr.splice(j, 1);
	// 				//因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
	// 				j--;
	// 			}
	// 		}
	// 	}
	// 	let newArr = [];
	// 	arr.forEach((item) => {
	// 		let obj = {
	// 			odrCustLnglat: item.odrCustLnglat,
	// 			odrIdArr: [],
	// 		};
	// 		oldArr.forEach((el) => {
	// 			if (item.odrCustLnglat == el.odrCustLnglat) {
	// 				let o = {
	// 					odrId: el.odrId,
	// 					odrRptName: el.odrRptName,
	// 					odrEndTime: el.odrEndTime,
	// 				};
	// 				obj.odrIdArr.push(o);
	// 			}
	// 		});
	// 		newArr.push(obj);
	// 	});
	// 	this.newArr = newArr;
	// };

	//初始化地图
	// const initPoints = () => {
	// 	//此处将数据换成官网需要的格式
	// 	var points = [];
	// 	data.maplist.forEach((item) => {
	// 		points.push({
	// 			lnglat: item.lnglat
	// 		});
	// 	});
	// 	var count = points.length;
	// 	//聚合样式
	// 	var _renderClusterMarker = function(context) {
	// 		var factor = Math.pow(context.count / count, 1 / 18);
	// 		var div = document.createElement("div");
	// 		var Hue = 180 - factor * 180;
	// 		var bgColor = "hsla(" + Hue + ",100%,40%,0.7)";
	// 		var fontColor = "hsla(" + Hue + ",100%,90%,1)";
	// 		var borderColor = "hsla(" + Hue + ",100%,40%,1)";
	// 		var shadowColor = "hsla(" + Hue + ",100%,90%,1)";
	// 		div.style.backgroundColor = bgColor;
	// 		var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
	// 		div.style.width = div.style.height = size + "px";
	// 		div.style.border = "solid 1px " + borderColor;
	// 		div.style.borderRadius = size / 2 + "px";
	// 		div.style.boxShadow = "0 0 5px " + shadowColor;
	// 		div.innerHTML = context.count;
	// 		div.style.lineHeight = size + "px";
	// 		div.style.color = fontColor;
	// 		div.style.fontSize = "14px";
	// 		div.style.textAlign = "center";
	// 		context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
	// 		context.marker.setContent(div);
	// 	};
	// 	var _renderMarker = function(context) {
	// 		//可以根据数据的不同类型进行判断
	// 		let img = require("@/assets/images/order-map.png");
	// 		let content = "";
	// 		content = "<img src=" + img + ' style="height: 30px; width: 30px;">';
	// 		var offset = new AMap.Pixel(-9, -9);
	// 		context.marker.setContent(content);
	// 		context.marker.setOffset(offset);
	// 	};

	// 	data.map.plugin(["AMap.MarkerClusterer"], function() {
	// 		data.cluster = new AMap.MarkerClusterer(
	// 			data.map, // 地图实例
	// 			data.maplist, // 海量点组成的数组
	// 			{
	// 				gridSize: 30,
	// 				zIndex: 2,
	// 				zoomOnClick: true,
	// 				renderClusterMarker: _renderClusterMarker,
	// 				renderMarker: _renderMarker,
	// 			}
	// 		);
	// 	});
	// 	this.cluster.on("click", (e) => {
	// 		console.log(e);

	// 		var zoom = data.map.getZoom(); // 获取当前地图级别
	// 		if (zoom < 20) {
	// 			zoom += 1;
	// 		}

	// 		if (data.isShowArea == true) {
	// 			data.isShow = false;
	// 			data.index = 1;
	// 			data.areaOrderList = [];
	// 			e.clusterData.forEach((item) => {
	// 				data.areaAllOrder.forEach((el) => {
	// 					if (item.odrCustLnglat === el.odrCustLnglat) {
	// 						data.areaOrderList.push(el);
	// 					}
	// 				});
	// 			});
	// 		}
	// 		console.log(data.isShowArea);
	// 		if (data.isShowArea == false) {
	// 			data.isShow = true;
	// 			data.orderList = [];
	// 			e.clusterData.forEach((item) => {
	// 				data.newArr.forEach((el) => {
	// 					if (item.odrCustLnglat == el.odrCustLnglat) {
	// 						el.odrIdArr.forEach((odr) => {
	// 							data.orderList.push(odr);
	// 						});
	// 					}
	// 				});
	// 			});
	// 		}
	// 		if (e.clusterData.length == 1) {
	// 			setInfoWindow(e.clusterData[0]);
	// 		}

	// 		data.map.setZoomAndCenter(zoom, [e.lnglat.lng, e.lnglat.lat]);
	// 	});
	// };

	// const setInfoWindow = async (item) => {
	// 	console.log(item);
	// 	const r = await proxy.$http.postFormData("/api/tencent/geocoder", {
	// 		location: item.lnglat,
	// 	});
	// 	if (r.info) {
	// 		var content = r.regeocode.formatted_address;
	// 		const infoWindow = new AMap.InfoWindow({
	// 			content, // 使用默认信息窗体框样式，显示信息内容
	// 			offset: new AMap.Pixel(0, -40),
	// 			closeWhenClickMap: true,
	// 		});
	// 		infoWindow.open(data.map, item.lnglat);
	// 	}
	// };

	// // 智能分析
	// anaslyseClick() {
	// 	if (this.circlesList.length > 0) {
	// 		this.circlesList.forEach((circle) => {
	// 			this.map.remove(circle);
	// 		});
	// 	}

	// 	this.isShow = false;
	// 	if (!this.radius || this.radius <= 0) {
	// 		this.$message.error("请输入半径");
	// 		return;
	// 	}
	// 	if (!this.minPoints || this.minPoints <= 0) {
	// 		this.$message.error("请输入聚集数量");
	// 		return;
	// 	}
	// 	this.$http
	// 		.postFormData("/biz/bdzl/advertising/odrGather", {
	// 			startTime: this.startTime ? this.startTime : "",
	// 			endTime: this.endTime ? this.endTime : "",
	// 			minPoints: this.minPoints,
	// 			radius: this.radius,
	// 			orgId: this.orgId,
	// 		})
	// 		.then((res) => {
	// 			console.log(res);
	// 			if (res.respCode === "0000") {
	// 				this.isShowArea = true;

	// 				// this.maplist = [];
	// 				this.areaAllOrder = [];
	// 				this.areaList = [];
	// 				this.areaOrderList = [];
	// 				res.odrGatherList.forEach((item) => {
	// 					this.$http
	// 						.postFormData("/api/tencent/geocoder", {
	// 							location: item.centerX + "," + item.centerY,
	// 						})
	// 						.then((res) => {
	// 							item.address = res.regeocode.formatted_address;
	// 							this.areaList.push(item);
	// 						});
	// 					if (item.odrList && item.odrList.length > 0) {
	// 						item.odrList.forEach((el) => {
	// 							let obj = {
	// 								lnglat: el.odrCustLnglat.split(","),
	// 								text: el.odrId,
	// 								odrCustLnglat: el.odrCustLnglat,
	// 							};
	// 							this.maplist.push(obj);
	// 							this.areaOrderList.push(el);
	// 							this.areaAllOrder.push(el);
	// 						});
	// 					}
	// 				});

	// 				this.circlesList = [];
	// 				res.odrGatherList.forEach((item) => {
	// 					let circle = this.createCircle(item);
	// 					this.circlesList.push(circle);
	// 				});

	// 				this.map.add(this.circlesList);
	// 				// this.initPoints();

	// 				this.odrGatherCount = res.odrGatherCount;
	// 				console.log(this.odrGatherCount);

	// 				//
	// 			} else {
	// 				this.$message.error(r.respMsg)
	// 			}
	// 		});
	// },
	// //圆形
	// // 创建圆形
	// createCircle(data) {
	// 	console.log(data);
	// 	let circle = new AMap.Circle({
	// 		center: [data.centerX, data.centerY],
	// 		radius: this.radius,
	// 		strokeColor: "#0658FF",
	// 		strokeWeight: 2,
	// 		strokeOpacity: 0.5,
	// 		fillColor: "#0658FF",
	// 		fillOpacity: 0.35,
	// 	});

	// 	return circle;
	// },
	// // 切换
	// changeTit(index) {
	// 	this.index = index;
	// },
	// // 区域点击
	// areaClick(item) {
	// 	this.map.setZoomAndCenter(15, [item.centerX, item.centerY]);
	// },
	// // 导出
	// async exprot(type) {
	// 	let params = {
	// 		startTime: this.startTime,
	// 		endTime: this.endTime,
	// 		minPoints: this.minPoints,
	// 		radius: this.radius,
	// 		orgId: this.orgId,
	// 	};
	// 	let url = "";
	// 	type == 1 ?
	// 		(url = "/biz/bdzl/advertising/exportOrDistribution") :
	// 		(url = "/biz/bdzl/advertising/exportOdrGather");
	// 	let FileName = "";
	// 	type == 1 ? "全部订单" : "聚集订单";
	// 	const r = await this.$http.downloadPostFormData(url, params, FileName);
	// },
	// clear() {
	// 	if (this.circlesList.length > 0) {
	// 		this.circlesList.forEach((circle) => {
	// 			this.map.remove(circle);
	// 		});
	// 	}
	// 	this.radius = null;
	// 	this.minPoints = null;
	// 	this.isShowArea = false;
	// 	this.areaAllOrder = [];
	// 	this.areaList = [];
	// 	this.areaOrderList = [];
	// 	this.getMapList();
	// },
</script>

<style scoped>
	.analyse-warp {
		padding: 0 25px;
		height: 70px;
		background: #fff;
		display: flex;
		align-items: center;
		border: 1px solid #e5e5e5;
		box-sizing: border-box;
	}

	.analyse-warp .btn {
		padding: 10.5px 30px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.content {
		position: relative;
		font-size: unset;
	}

	#map-container {
		/* width: 100%;
		height: 100%;*/
		/* height: calc(100% - 100px); */
		/* position: relative; */

		width: 100%;
		height: 100%;

		position: absolute;

		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
	}

	#container {
		width: 100%;
	}

	.order-container {
		position: relative;
		margin-top: 10px;
		width: 350px;
		height: calc(95% - 20px);
		background: #fff;
		z-index: 10;
		border: 1px solid #e5e5e5;
		border-top: none;
		float: right;
	}

	.order-tit {
		width: 100%;
		height: 50px;
		border-bottom: 1px solid #e5e5e5;
		font-size: 16px;
		color: #333;
		text-align: center;
		text-indent: 30px;
		line-height: 50px;
		font-weight: 400;
	}

	.order-tit span {
		cursor: pointer;
		margin-right: 20px;
		background: #ffffff !important;
		color: #000000 !important;
	}

	.order-tit span.active {
		background: #ffffff !important;
		color: #243290 !important;
	}

	.order-list {
		width: 100%;
		height: calc(100% - 50px);
		overflow: auto;
	}

	.order-item {
		width: 100%;
		padding-top: 15px;
		padding-bottom: 10px;
		border-bottom: 1px solid #e5e5e5;
		display: flex;
	}

	.order-item img {
		width: 20px;
		height: 20px;
		margin-left: 20px;
	}

	.order {
		flex: 1;
		margin-left: 10px;
	}

	.order div {
		font-size: 14px;
		text-align: left;
		margin-bottom: 5px;
		font-size: 12px;
		color: #666;
	}

	.order div:nth-of-type(1) {
		font-size: 14px;
		color: #333;
	}

	.address {
		/* width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
		width: 145px;
	}

	.maptop_input {
		width: 150px;
		height: 30px;
	}

	.mapsearch_btn {
		width: 90px;
		height: 30px;
		background: #243290;
		border-radius: 4px;
		cursor: pointer;
		text-align: center;
		line-height: 30px;
		font-size: 14px;
		color: #ffffff;
		margin-left: 10px;
	}

	.bottom_content {
		width: 100%;
		height: calc(100% - 120px - 20px);
		background: #ffffff;
	}

	.bottom_content .table_container {
		width: calc(100% - 20px);
		height: calc(100% - 80px);
		margin: 0 auto;
		padding-top: 10px;
	}

	.marker-image {
		width: 40px;
		height: 40px;
	}

	.amap-container img {
		width: 40px;
		height: 40px;
	}

	#countdown {
		display: inline-block;
		position: absolute;
		left: 2.5%;
		top: 2.5%;
		font-size: 14px;
		margin-left: 15px;
		color: #000000;
		z-index: 999;
		padding: 5px 8px;
		background: #e5e5e5;
	}

	#countdown #countDownTime {
		color: #ff5037;
		width: 15px;
		display: inline-block;
		text-align: center;
	}
</style>